/* eslint-disable prettier/prettier */
import * as React from "react";
import { Button, Grid, Modal as MuiModal, Typography } from "@mui/material";
import { ClearIcon } from "@mui/x-date-pickers/icons";

import { getHeaders } from "../../utils/HeaderHelper";
import { useFlash } from "../../FlashContext";

interface Props {
  csrfToken: string;
  deleteModalHandler: any;
  setDeleteModalHandler: any;
  getCustomerUsers: any;
}

const CoreTeamCustomerAssociationModalDelete: React.FC<Props> = (
  props: any
) => {
  const { showToast } = useFlash();

  const handleCustomerUserSave = () => {
    fetch(
      `/provider_customer_users/${props.deleteModalHandler.customerUserId}`,
      {
        method: "DELETE",
        headers: getHeaders(props.csrfToken),
      }
    )
      .then((result) => result.json())
      .then((result) => {
        if (result.success) {
          showToast({
            title: "Association Deleted",
            text: "Association deleted successfully",
            type: "success",
          });
          props.setDeleteModalHandler({ open: false, customerUserId: null });
          props.getCustomerUsers();
        } else {
          showToast({
            title: "Error",
            text: result.error,
            type: "error",
          });
        }
      })
      .catch((error) => {
        showToast({
          title: "Network or Server Error",
          text: "Something went wrong while deleting the association",
          type: "error",
        });
      });
  };

  const handleClose = () => {
    props.setDeleteModalHandler({
      open: false,
      customerUserId: null,
    });
  };

  return (
    <MuiModal
      open={props.deleteModalHandler.open}
      className="modal-primary"
      onClose={handleClose}
    >
      <div className="paper" style={{ width: 430 }}>
        <div className="paperInner">
          <Grid container>
            <Grid item xs={12}>
              <div className="main-header" style={{ marginBottom: "20px" }}>
                <span>Deactivate Provider Association</span>
                <span id="dismiss-button" onClick={handleClose}>
                  <ClearIcon sx={{ width: 30, height: 30 }} />
                </span>
              </div>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                paddingLeft: "24px",
                paddingRight: "24px",
              }}
            >
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: 500,
                  lineHeight: "22px",
                  color: "#1E1E1E",
                  textAlign: "center",
                }}
              >
                Deactivating the provider from this association will no longer
                allow this provider to have access to that organization. Are you
                sure you want to continue?
              </Typography>
            </Grid>
          </Grid>

          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            className="modal-footer"
          >
            <Grid item xs={12} className="confirm-btn-container">
              <div onClick={handleClose} className="cancel-link">
                Cancel
              </div>
              <Button
                onClick={handleCustomerUserSave}
                className="confirm-btn"
                style={{ width: 156 }}
              >
                Confirm
              </Button>
            </Grid>
          </Grid>
        </div>
      </div>
    </MuiModal>
  );
};

export default CoreTeamCustomerAssociationModalDelete;
